export default __webpack_public_path__ + "static/media/include_9_male@3x.928b7245.jpg";